import lazyLoading from '@src/components/widgets/LazyLoading'
import { ACCESS } from '@src/configs/permission'
import OptionPageTermPolicy from '@src/pages/option/term-policy'
import React from 'react'
import { PathRouteProps } from 'react-router-dom'

export interface TRouteConfig extends PathRouteProps {
  Element: React.FC
  key: ACCESS
}

const Dashboard = lazyLoading(() => import('@pages/dashboard'))

const Role = lazyLoading(() => import('@pages/role'))
const Rating = lazyLoading(() => import('@src/pages/rating'))
const PostRating = lazyLoading(() => import('@src/pages/post-rating'))

const User = lazyLoading(() => import('@pages/user'))
const CreateUser = lazyLoading(() => import('@pages/user/create'))
const DetailUser = lazyLoading(() => import('@pages/user/detail'))
const ManageAccount = lazyLoading(() => import('@pages/user/account'))
const Profile = lazyLoading(() => import('@pages/user/profile'))

const Reward = lazyLoading(() => import('@src/pages/reward'))
const CreateReward = lazyLoading(() => import('@src/pages/reward/create'))
const RewardUser = lazyLoading(() => import('@src/pages/reward/screens/reward-user'))

const SpecialDeal = lazyLoading(() => import('@src/pages/special-deal'))
const DetailSpecialDeal = lazyLoading(() => import('@src/pages/special-deal/detail'))
const CreateSpecialDeal = lazyLoading(() => import('@src/pages/special-deal/create'))
const SpecialDealUser = lazyLoading(() => import('@src/pages/special-deal/screens/special-deal-user'))

const Media = lazyLoading(() => import('@pages/media'))

const Post = lazyLoading(() => import('@pages/post'))
const CreatePost = lazyLoading(() => import('@pages/post/create'))
const DetailPost = lazyLoading(() => import('@pages/post/detail'))
const Category = lazyLoading(() => import('@pages/post/category'))
const CreateCategory = lazyLoading(() => import('@pages/post/category/create'))
const DetailCategory = lazyLoading(() => import('@pages/post/category/detail'))
const DetailReward = lazyLoading(() => import('@src/pages/reward/detail'))

const Event = lazyLoading(() => import('@pages/event'))
const CreateEvent = lazyLoading(() => import('@pages/event/create'))
const DetailEvent = lazyLoading(() => import('@pages/event/detail'))
const EventWish = lazyLoading(() => import('@pages/event/wish'))

const NotificationTemplate = lazyLoading(() => import('@pages/notification-template'))
const CreateNotificationTemplate = lazyLoading(() => import('@pages/notification-template/create'))
const DetailNotificationTemplate = lazyLoading(() => import('@src/pages/notification-template/detail'))

const Game = lazyLoading(() => import('@pages/game'))
const CreateGame = lazyLoading(() => import('@pages/game/create'))
const DetailGame = lazyLoading(() => import('@pages/game/detail'))

const FAQOption = lazyLoading(() => import('@src/pages/option/faq'))
const ContactOption = lazyLoading(() => import('@src/pages/option/contact'))
const IntroOption = lazyLoading(() => import('@src/pages/option/introduction'))
const OwnerOption = lazyLoading(() => import('@src/pages/option/ownership'))
const HomeOption = lazyLoading(() => import('@src/pages/option/home'))
const SpecialDealOption = lazyLoading(() => import('@src/pages/option/special-deal'))
const EventOption = lazyLoading(() => import('@src/pages/option/event'))

const Analytics = lazyLoading(() => import('@pages/analytics'))

const routeConfig: TRouteConfig[] = [
  {
    path: '/',
    Element: Dashboard,
    key: ACCESS.GENERAL,
  },
  {
    path: '/analytics',
    Element: Analytics,
    key: ACCESS.LIST_USERS,
  },

  {
    path: '/reward',
    Element: Reward,
    key: ACCESS.LIST_REWARD,
  },
  {
    path: '/create-reward',
    Element: CreateReward,
    key: ACCESS.CREATE_REWARD,
  },
  {
    path: '/reward/:id',
    Element: DetailReward,
    key: ACCESS.VIEW_REWARD,
  },

  // Reward user
  {
    path: '/reward-user',
    Element: RewardUser,
    key: ACCESS.LIST_REWARD_USER,
  },
  // Special Deal
  {
    path: '/special-deal',
    Element: SpecialDeal,
    key: ACCESS.LIST_SPECIAL_DEAL_USER,
  },
  {
    path: '/create-special-deal',
    Element: CreateSpecialDeal,
    key: ACCESS.CREATE_SPECIAL_DEAL,
  },
  {
    path: '/special-deal/:id',
    Element: DetailSpecialDeal,
    key: ACCESS.VIEW_SPECIAL_DEAL,
  },

  // Special Deal user
  {
    path: '/special-deal-user',
    Element: SpecialDealUser,
    key: ACCESS.LIST_SPECIAL_DEAL_USER,
  },
  // Role
  {
    path: '/role',
    Element: Role,
    key: ACCESS.LIST_ROLES,
  },
  {
    path: '/create-role',
    Element: Role,
    key: ACCESS.CREATE_ROLE,
  },
  {
    path: '/role/:id',
    Element: Role,
    key: ACCESS.VIEW_ROLE,
  },

  // User
  {
    path: '/user',
    Element: User,
    key: ACCESS.LIST_USERS,
  },
  {
    path: '/create-user',
    Element: CreateUser,
    key: ACCESS.CREATE_USER,
  },
  {
    path: '/user/:id',
    Element: DetailUser,
    key: ACCESS.VIEW_USER,
  },
  {
    path: '/profile',
    Element: Profile,
    key: ACCESS.GENERAL,
  },
  // Manage account
  {
    path: '/employee',
    Element: ManageAccount,
    key: ACCESS.LIST_ACCOUNT,
  },
  // Notification
  {
    path: '/notification-template',
    Element: NotificationTemplate,
    key: ACCESS.LIST_NOTIFICATION_TEMPLATE,
  },
  {
    path: '/create-notification-template',
    Element: CreateNotificationTemplate,
    key: ACCESS.CREATE_NOTIFICATION_TEMPLATE,
  },
  {
    path: '/notification-template/:id',
    Element: DetailNotificationTemplate,
    key: ACCESS.VIEW_NOTIFICATION_TEMPLATE,
  },
  // Media
  {
    path: '/media',
    Element: Media,
    key: ACCESS.LIST_MEDIAS,
  },

  // Option
  {
    path: 'option/faq',
    Element: FAQOption,
    key: ACCESS.LIST_OPTION,
  },
  {
    path: 'option/contact',
    Element: ContactOption,
    key: ACCESS.LIST_OPTION,
  },
  {
    path: 'option/introduction',
    Element: IntroOption,
    key: ACCESS.LIST_OPTION,
  },
  {
    path: 'option/ownership',
    Element: OwnerOption,
    key: ACCESS.LIST_OPTION,
  },
  {
    path: 'option/home',
    Element: HomeOption,
    key: ACCESS.LIST_OPTION,
  },
  {
    path: 'option/term-policy',
    Element: OptionPageTermPolicy,
    key: ACCESS.LIST_OPTION,
  },
  {
    path: 'option/special-deal',
    Element: SpecialDealOption,
    key: ACCESS.LIST_OPTION,
  },
  // Post
  {
    path: '/post',
    Element: Post,
    key: ACCESS.LIST_POST,
  },
  {
    path: '/create-post',
    Element: CreatePost,
    key: ACCESS.CREATE_POST,
  },
  {
    path: '/post/:id',
    Element: DetailPost,
    key: ACCESS.VIEW_POST,
  },
  {
    path: '/category',
    Element: Category,
    key: ACCESS.LIST_TAXONOMY,
  },
  {
    path: '/create-category',
    Element: CreateCategory,
    key: ACCESS.LIST_TAXONOMY,
  },
  {
    path: '/detail-category/:id',
    Element: DetailCategory,
    key: ACCESS.LIST_TAXONOMY,
  },

  // Event
  {
    path: '/event',
    Element: Event,
    key: ACCESS.LIST_POST,
  },
  {
    path: '/create-event',
    Element: CreateEvent,
    key: ACCESS.CREATE_POST,
  },
  {
    path: '/event/:id',
    Element: DetailEvent,
    key: ACCESS.VIEW_POST,
  },
  {
    path: '/event-wish',
    Element: EventWish,
    key: ACCESS.VIEW_POST,
  },
  {
    path: '/event-settings',
    Element: EventOption,
    key: ACCESS.LIST_OPTION,
  },
  // Rating
  {
    path: '/rating',
    Element: Rating,
    key: ACCESS.LIST_APP_RATING,
  },
  {
    path: '/post-rating',
    Element: PostRating,
    key: ACCESS.LIST_POST_RATING,
  },
  // Game
  {
    path: '/game',
    Element: Game,
    key: ACCESS.LIST_CONTEST,
  },
  {
    path: '/create-game',
    Element: CreateGame,
    key: ACCESS.CREATE_CONTEST,
  },
  {
    path: '/game/:id',
    Element: DetailGame,
    key: ACCESS.VIEW_CONTEST,
  },
]

export default routeConfig
